import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ProfileService } from '../../services/profile.service';
import { NaviService } from '../../services/navi.service';
import { AuthenticationService } from '../../services/authentication.service';
import { AlarmService } from '../../services/alarm.service';

import { BasicError } from '../../models/error/error';
import { User } from '../../models/user';
import { Alarm } from '../../models/alarm';
declare var $: any;

@Component({
  selector: 'app-hcp-navi',
  templateUrl: './hcp-navi.component.html',
  styleUrls: ['./hcp-navi.component.css']
})
export class HcpNaviComponent implements OnInit, AfterViewInit {
  public name: String = '...';
  public img: String = 'assets/img/user.png';
  public currentPage: String = '';

  public roles: String[] = [];
  public hasRights: Boolean = false;
  public alarms: Array<Alarm> = [];
  public warnings: Array<Alarm> = [];

  constructor(private profileService: ProfileService, private naviService: NaviService,
    private auth: AuthenticationService, private alarmService: AlarmService) {
    // Get currentPage
    this.currentPage = this.naviService.getCurrentPage();

    // Register on pageChange
    this.naviService.pageChanger.subscribe(nextPage => {
      this.currentPage = nextPage;
    });

    this.profileService.getMyProfile().subscribe(user => {
      if (user instanceof BasicError) {
        // Error handling needed?
        console.log('An error occured: ' + user.status)
      } else if (user instanceof User) {
        this.name = user.getFirstName() + ' ' + user.getLastName();
        if (user.getPicture() !== undefined && user.getPicture() !== null) {
          this.img = user.getPicture();
        }
      }
    });

    this.profileService.getMyRoles().subscribe(roles => {
      if (roles instanceof BasicError) {
        console.log('Erro occured, no roles could be retrieved!');
      } else if (roles instanceof Array) {
        if (roles.length > 0) {
          this.hasRights = true;
        }

        this.roles = roles;
      }
    });

    // Register to service and hope that it works
    this.alarmService.observe().subscribe(json => {
      const rr = this.alarmService.getCurrentAlarms();
      this.alarms = rr.alarms;
      this.warnings = rr.warnings;
      setTimeout(function () {
        $('[data-toggle="tooltip"]').tooltip();
      }, 200);
    });

    const rr = this.alarmService.getCurrentAlarms();
    this.alarms = rr.alarms;
    this.warnings = rr.warnings;
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    $('#sidebar-menu li:has(> ul.child_menu)').each(function () {
      $(this).click(function (event) {
        event.stopPropagation();
        $(this).toggleClass('active');
        $(this).find('> ul.child_menu').each(function () {
          // this.style.display = 'block';
          $(this).slideToggle('fast');
        });
      });
    });

    $(document).ready(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });

    $(document).ready(function () {
      const rightCol = $('.main_container .right_col').get(0);
      const footer = $('footer').get(0);

      if (rightCol === undefined || rightCol === null) {
        return;
      }

      let winHeight = $(window).height() - 2;
      winHeight = (footer !== null || footer !== undefined) ? winHeight - $(footer).outerHeight(true) : winHeight;

      $(rightCol).css({ 'min-height': winHeight + 'px' });

    });
  }


  /**
  * This function logs the current user out of the system
  */
  public logout(): void {
    this.auth.logout();
  }

  /**
   * Navigate to follow string
   * @param name string to navigate to
   */
  public navigate(name: String): void {
    this.naviService.setCurrentPage(name);
  }

}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/components/hcp-navi/hcp-navi.component.ts